module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-wil-combineren page",
    attrs: {
      "id": "page-wil-combineren"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_c('h1', [_vm._v("Waar wil jij je huidige werk mee combineren?")]), _vm._v(" "), _c('div', {
    staticClass: "container list-select"
  }, [_vm._l((_vm.jobTypes), function(type) {
    return _c('div', {
      staticClass: "list-select__item row",
      class: {
        'list-select__item--selected': type === _vm.newJob
      },
      on: {
        "click": function($event) {
          _vm.selectType(type)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "col-10-sm list-select__item-text"
    }, [_vm._v("\n                    " + _vm._s(type.label) + "\n                ")])])
  }), _vm._v(" "), (_vm.newJob) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm list-select__title"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.nextHandler
    }
  }, [_vm._v("Volgende")])])]) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-2-sm list-select__item-marker-column"
  }, [_c('div', {
    staticClass: "list-select__item-marker"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4351216","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-wil-combineren.vue
// module id = 153
// module chunks = 0